/* eslint-disable jsx-a11y/anchor-is-valid */
import AssignmentIcon from '@mui/icons-material/Assignment';
import AttributionOutlinedIcon from '@mui/icons-material/AttributionOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import MenuIcon from '@mui/icons-material/Menu';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import logo from '../../../assets/img/logo/logo.png';
import userImg from '../../../assets/img/user.png';
import governanceIcon from '../../../assets/img/icons/governance.png';
import { Flex, MHeading } from '../../../styledComponents';
import { colors } from '../../../utils';
import DrawerList from './DrawerList';
import {
	ClickOnHover,
	FooterUserImg,
	MainMenu,
	Sidebar,
	SidebarFooter,
	SidebarHeader,
	SidebarLogo,
	ToggleMenu,
} from './styledComponents';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import CategoryIcon from '@mui/icons-material/Category';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyIcon from '@mui/icons-material/Key';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import PendingIcon from '@mui/icons-material/Pending';
import SchoolIcon from '@mui/icons-material/School';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import GroupIcon from '@mui/icons-material/Group';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import QuizIcon from '@mui/icons-material/Quiz';
import SourceIcon from '@mui/icons-material/Source';
import MicIcon from '@mui/icons-material/Mic';
import SlideshowIcon from '@mui/icons-material/Slideshow';


const { colorWhite, primaryText, secondaryText, colorPrimary } = colors;

const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#333',
		color: primaryText,
		boxShadow: theme.shadows[1],
		fontSize: 11,
	},
}));

// Icons Styling
const iconStyle = { fontSize: '2rem' };

const menuListStyle = { fontSize: '1.8rem', color: colorPrimary };

function Drawer({ routesWidthChange }) {
	const { userProfileId, departmentId, fullName, mainMenu } = useSelector(
		(state) => state?.activeAccount,
	);

	const { isLoggedIn } = useSelector((state) => state.activeAccount);
	const [drawer, setDrawer] = useState(true);
	const [windowWidth, setWindowWidth] = useState(window.outerWidth);
	const Dashboardicon = DashboardIcon;
	const dispatch = useDispatch();

	useEffect(() => {
		if (isLoggedIn) {
			routesWidthChange(drawer);
		}
	}, [drawer, isLoggedIn, routesWidthChange]);









	// Menu and SubMenu List
	const menuItems = [
		{
			name: 'Dashboard',
			to: '/',
			menuIcon: <DashboardIcon style={menuListStyle} />,
			tooltipText: 'Dashboard',
		},
		{
			name: 'Company Profile',
			to: '/company-profile',
			menuIcon: <AccountBoxIcon style={menuListStyle} />,
			tooltipText: 'Company Profile',
		},
		{
			name: 'About Us',
			to: '/about-us',
			menuIcon: <AccountBoxIcon style={menuListStyle} />,
			tooltipText: 'About Us',
		},
		{
			name: 'Slider',
			to: '/slider',
			menuIcon: <LinearScaleIcon style={menuListStyle} />,
			tooltipText: 'Slider',
		},
		{
			name: 'Shareholder Rights',
			// to: '/Posts',
			menuIcon: <GroupsIcon style={menuListStyle} />,
			tooltipText: 'Shareholder Rights',
			subMenus: [
				{
					menuIcon: <ArticleIcon style={menuListStyle} />,
					name: 'Documents',
					to: '/shareholder-rights/documents',
				},
				{
					menuIcon: <OndemandVideoIcon style={menuListStyle} />,
					name: 'Videos',
					to: '/shareholder-rights/videos',
				},
				{
					menuIcon: <OndemandVideoIcon style={menuListStyle} />,
					name: 'Webinars',
					to: '/shareholder-rights/webinars',
				},
				{
					menuIcon: <LiveHelpIcon style={menuListStyle} />,
					name: 'Faqs',
					to: '/shareholder-rights/faqs',
				},
			]
		},
		{
			name: 'Shareholder Education',
			// to: '/Posts',
			menuIcon: <SchoolIcon style={menuListStyle} />,
			tooltipText: 'Shareholder Education',
			subMenus: [
				{
					menuIcon: <ArticleIcon style={menuListStyle} />,
					name: 'Webinars',
					to: '/shareholder-education/webinars',
				},

				{
					menuIcon: <LibraryBooksIcon style={menuListStyle} />,
					name: 'Courses',
					to: '/shareholder-education/courses',
				},
				{
					menuIcon: <LibraryBooksIcon style={menuListStyle} />,
					name: 'Course Category',
					to: '/shareholder-education/courses-categories',
				},
				{
					menuIcon: <QuizIcon style={menuListStyle} />,
					name: 'Quizzes',
					to: '/shareholder-education/quizzes',
				},
				{
					menuIcon: <MicIcon style={menuListStyle} />,
					name: 'Podcasts',
					to: '/shareholder-education/podcasts',
				},
				{
					menuIcon: <SlideshowIcon style={menuListStyle} />,
					name: 'Presentations',
					to: '/shareholder-education/presentations',
				},
				{
					menuIcon: <img src={governanceIcon} alt="Governance" style={{ width: '2.1rem', height: '2.1rem', filter: 'invert(78%) sepia(45%) saturate(497%) hue-rotate(79deg) brightness(95%) contrast(85%)' }} />,
					name: 'Governance Updates',
					to: '/shareholder-education/governance-updates',
				},

			]
		},

		{
			name: 'Library',
			// to: '/Posts',
			menuIcon: <AutoStoriesIcon style={menuListStyle} />,
			tooltipText: 'Library',
			subMenus2: [
				{
					name: 'Regulatory Information',
					// to: '/Posts',
					menuIcon: <CategoryIcon style={menuListStyle} />,
					tooltipText: 'Regulatory Information',
					subMenus: [
						{
							menuIcon: <ArticleIcon style={menuListStyle} />,
							name: 'All Posts',
							to: '/corporate-governance-library/legal-and-regulatory/posts',
						},
						{
							menuIcon: <CategoryIcon style={menuListStyle} />,
							name: 'Categories',
							to: '/corporate-governance-library/legal-and-regulatory/categories',
						},
						{
							menuIcon: <SourceIcon style={menuListStyle} />,
							name: 'Resources',
							to: '/corporate-governance-library/legal-and-regulatory/resources',
						},
					]
				},
				{
					name: 'Resources',
					// to: '/Posts',
					menuIcon: <CategoryIcon style={menuListStyle} />,
					tooltipText: 'Resources',
					subMenus: [
						{
							menuIcon: <ArticleIcon style={menuListStyle} />,
							name: 'All Posts',
							to: '/corporate-governance-library/information-repository/posts',
						},
						{
							menuIcon: <CategoryIcon style={menuListStyle} />,
							name: 'Categories',
							to: '/corporate-governance-library/information-repository/categories',
						},
						{
							menuIcon: <SourceIcon style={menuListStyle} />,
							name: 'Resources',
							to: '/corporate-governance-library/information-repository/resources',
						},
					]
				},
				{
					name: 'News',
					// to: '/Posts',
					menuIcon: <CategoryIcon style={menuListStyle} />,
					tooltipText: 'News',
					subMenus: [
						{
							menuIcon: <NewspaperIcon style={menuListStyle} />,
							name: 'General News',
							to: '/corporate-governance-library/news/governance-news',
						},
						// {
						// 	menuIcon: <NewspaperIcon style={menuListStyle} />,
						// 	name: 'Specific News',
						// 	to: '/corporate-governance-library/news/company-news',
						// },
					]
				},

			],
		},
		{
			name: 'E-Services',
			// to: '/Posts',
			menuIcon: <RssFeedIcon style={menuListStyle} />,
			tooltipText: 'E-Services',
			subMenus: [
				{
					menuIcon: <HowToVoteIcon style={menuListStyle} />,
					name: 'E-Voting / E-Meeting',
					to: '/e-service/e-voting',
				},

			]
		},
		{
			name: 'Settings',
			// to: '/Posts',
			menuIcon: <SettingsIcon style={menuListStyle} />,
			tooltipText: 'Settings',
			subMenus: [
				{
					menuIcon: <KeyIcon style={menuListStyle} />,
					name: 'Permissions',
					to: '/permissions',
				},
				{
					menuIcon: <ManageAccountsIcon style={menuListStyle} />,
					name: 'Roles',
					to: '/roles',
				},
				{
					menuIcon: <GroupIcon style={menuListStyle} />,
					name: 'Users',
					to: '/users',
				},
			]
		},
		{
			name: 'Pending Requests',
			to: '/pending-requests',
			menuIcon: <PendingIcon style={menuListStyle} />,
			tooltipText: 'Pending Requests',
		},
		{
			name: 'Complaint Forms',
			to: '/complaint-forms',
			menuIcon: <PendingIcon style={menuListStyle} />,
			tooltipText: 'Complaint Forms',
		},

	];


	const filterSubMenus = (subMenus) => {
		return subMenus
			?.filter((subMenu) => {
				const routeKey = `FRONT:${subMenu.to}`;
				return mainMenu[routeKey] === 1; // Only include submenus present in mainMenu with value 1
			})
			.map((subMenu) => ({
				...subMenu,
				subMenus: filterSubMenus(subMenu.subMenus || []), // Recursively filter nested submenus
			}));
	};


	const filterMenuTree = (items) => {
		return items
			?.filter((item) => {
				const routeKey = item.to ? `FRONT:${item.to}` : null;
				const hasValidSubMenus = item.subMenus && filterMenuTree(item.subMenus).length > 0;
				const hasValidSubMenus2 = item.subMenus2 && filterMenuTree(item.subMenus2).length > 0;
				return (routeKey && mainMenu[routeKey] === 1) || hasValidSubMenus || hasValidSubMenus2;
			})
			.map((item) => ({
				...item,
				subMenus: filterMenuTree(item.subMenus || []),
				subMenus2: filterMenuTree(item.subMenus2 || []),
			}));
	};

	const filteredMenuItems = filterMenuTree(menuItems);


	// const filteredMenuItems = menuItems.filter((menu) => {
	// 	const routeKey = `FRONT:${menu.to}`;
	// 	return mainMenu[routeKey] === 1; // Only include items present in mainMenu with value 1
	// });

	const handleResize = () => {
		setWindowWidth(window.outerWidth);
	};

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [windowWidth]);
	return (
		// Sidebar Open
		<Sidebar maxWidth={!drawer && '6rem'}>
			{/* Sidebar Header */}
			<SidebarHeader jc={!drawer && 'center'}>

				{/* {drawer && (
					<SidebarLogo>
						<img src={logo} alt='DocLink' />
					</SidebarLogo>
				)} */}

				<ToggleMenu
					onClick={() => {
						// if (windowWidth <= 600) {
						// setDrawer(false);
						// }
						// if (windowWidth > 600) {
						setDrawer(!drawer);
						// }
					}}>
					{!drawer ? (
						<LightTooltip
							title={windowWidth > 600 ? 'Open Menu' : 'Disabled'}
							placement='right-start'>
							<MenuIcon
								sx={{
									fontSize: '3rem !important',
									marginLeft: '0.1',
									color: windowWidth > 600 ? primaryText : secondaryText,
								}}
							/>
						</LightTooltip>
					) : (
						<ClickOnHover>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								height='2em'
								viewBox='0 0 24 24'
								width='2em'
								fill={colorWhite}
								className=''
								data-name='Material--FirstPage'>
								<path d='M24 0v24H0V0h24z' fill='none' opacity='0.87'></path>
								<path d='M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z'></path>
							</svg>
						</ClickOnHover>
					)}
				</ToggleMenu>
				{/* Menu Icon End */}
			</SidebarHeader>
			{/* Sidebar Header End */}

			{/* Main Menu */}
			<MainMenu ml={!drawer && '0.5rem'}>
				{/* dynamic by api */}
				{filteredMenuItems?.length &&
					// roleCheck?.length && roleCheck[0]?.id === RoleName?.SuperAdmin &&
					filteredMenuItems?.map((menu) => {

						const { name, menuIcon, to, subMenus, subMenus2, tooltipText, html } = menu;
						return (
							<DrawerList
								key={menu.name}
								drawer={drawer}
								iconStyle={iconStyle}
								name={name}
								menuIcon={menuIcon}
								to={to}
								html={html}
								subMenus={subMenus || []}
								subMenus2={subMenus2 || []}
								tooltipText={tooltipText}
								setDrawer={setDrawer}
							/>
						);
					})}


			</MainMenu>



			{/* footer */}
			{drawer && (
				<SidebarFooter>
					<Flex gap='1rem'>
						<FooterUserImg>
							<img src={userImg} alt='user' height='33' width='33' />
						</FooterUserImg>
						<div>
							<MHeading mb='0.2em'>
								{fullName}{' '}
								{/* <VerifiedOutlinedIcon
									style={{
										color: colorDarkBlue,
										fontSize: '1.1rem',
									}}
								/> */}
							</MHeading>
							{/* <Text fs='0.9rem'>CEO, Founder</Text> */}
						</div>
					</Flex>
				</SidebarFooter>
			)}
			{/* Main Menu End */}
		</Sidebar>
		// Sidebar End
	);
}

export default Drawer;
